<div nz-row class="budget-list-container">
  <div nz-col nzSpan="22" nzOffset="1">
  <div class="title-row">
    <h1 nz-typography>Bugete - Toate</h1>
    <button nz-button nzType="primary" nzShape="round" (click)="openMyBudget.emit()"
      style="display: inline-flex; align-items: center; gap: 6px;">
      <i nz-icon nzType="user" nzTheme="outline"></i>
      <span>Vizualizează bugetul meu</span>
    </button>
  </div>

  <div class="top-content">
    <div class="pagination">
      <nz-pagination
        [(nzPageIndex)]="pageIndex"
        [nzTotal]="totalPages * pageSize"
        [(nzPageSize)]="pageSize"
        [nzPageSizeOptions]="[10, 20, 30, 40, 100]"
        nzShowSizeChanger
        (nzPageIndexChange)="onPageChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      ></nz-pagination>
    </div>
  </div>

  <nz-table
    #budgetListTable
    [nzData]="budgets"
    [nzLoading]="loading"
    nzSize="small"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
  >
    <thead>
      <tr>
        <th nzCustomFilter nzWidth="180px">
          <input nz-input placeholder="Nume" nzBorderless (keyup)="onFilterChange()" [(ngModel)]="searchName" />
        </th>
        <th nzWidth="80px" style="text-align: center;">Buget Realist</th>
        <th nzWidth="80px" style="text-align: center;">Buget Pesimist</th>
        <th nzWidth="80px" style="text-align: center;">Comparație</th>
        <th nzWidth="170px">Perioada</th>
        <th nzCustomFilter nzWidth="170px" nz-tooltip="Filtru pentru data creării">
          <nz-date-picker nzBorderless nzMode="month" [(ngModel)]="searchDateValue"
            nzPlaceHolder="DATA CREARE" (ngModelChange)="onDateFilterChange($event)"></nz-date-picker>
        </th>
        <th nzCustomFilter nzWidth="180px">
          <input nz-input placeholder="Utilizator" nzBorderless (keyup)="onFilterChange()" [(ngModel)]="searchUser" />
        </th>
        <th nzCustomFilter nzWidth="220px">
          <input nz-input placeholder="Email" nzBorderless (keyup)="onFilterChange()" [(ngModel)]="searchEmail" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let budget of budgetListTable.data">
        <td>{{ budget.name }}</td>
        <td style="text-align: center;">
          <a *ngIf="budget.realisticId"
             (click)="onViewBudget(budget.realisticId)"
             nz-button nzType="primary" nzShape="circle"
             nz-tooltip nzTooltipTitle="Vizualizare buget realist">
            <i nz-icon nzType="eye" nzTheme="outline"></i>
          </a>
          <span *ngIf="!budget.realisticId" class="no-data">—</span>
        </td>
        <td style="text-align: center;">
          <a *ngIf="budget.pessimisticId"
             (click)="onViewBudget(budget.pessimisticId)"
             nz-button nzType="primary" nzShape="circle"
             nz-tooltip nzTooltipTitle="Vizualizare buget pesimist">
            <i nz-icon nzType="eye" nzTheme="outline"></i>
          </a>
          <span *ngIf="!budget.pessimisticId" class="no-data">—</span>
        </td>
        <td style="text-align: center;">
          <a *ngIf="budget.realisticId"
             (click)="onViewComparison(budget.realisticId)"
             nz-button nzShape="circle"
             nz-tooltip nzTooltipTitle="Vizualizare comparație"
             style="background-color: #722ed1; border-color: #722ed1; color: #fff;">
            <i nz-icon nzType="bar-chart" nzTheme="outline"></i>
          </a>
          <span *ngIf="!budget.realisticId" class="no-data">—</span>
        </td>
        <td>{{ getPeriodLabel(budget) }}</td>
        <td>{{ budget.dateCreated | date:'dd.MM.yyyy HH:mm' }}</td>
        <td>{{ budget.userFirstName }} {{ budget.userLastName }}</td>
        <td>{{ budget.userEmail }}</td>
      </tr>
    </tbody>
  </nz-table>

  <div class="pagination-bar">
    <nz-pagination
      [(nzPageIndex)]="pageIndex"
      [nzTotal]="totalPages * pageSize"
      [(nzPageSize)]="pageSize"
      [nzPageSizeOptions]="[10, 20, 30, 40, 100]"
      nzShowSizeChanger
      (nzPageIndexChange)="onPageChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)"
    ></nz-pagination>
  </div>
  </div>
</div>
